
const items = {
    items: [
        "<span class='text-secondary'>Regular Cash Flows:</span> Regular principal repayment along with monthly interest receipts thus reducing credit risk.",
        "<span class='text-secondary'>Good quality lending book:</span> 65% of the total lending book (Gold Loans + LAP) is secured.",
        "<span class='text-secondary'>Promoter Pedigree:</span> The promoter (Ms. Padmaja Reddy) has vast experience in the lending sector and can infuse equity capital in the company if and when required.",
        "<span class='text-secondary'>Low Capital Gearing:</span> The Debt Equity ratio of the company is 2.9x as of Mar’23. The company is expected to maintain a Debt Equity ratio of less than 4x.",
        "Lenders to Keertana include IDFC Bank, Kotak Mahindra bank, Aditya Birla Capital, Yes Bank, Ambit, Oxyzo, Sundaram Finance, Vivritti Capital among many others.",
        "The issue is listed on the exchange and investments in this bond will be credited to your DEMAT account."
      ]
  }
  
  export default items;